import { gsap } from 'gsap';

const init = () => {
  const viewMoreElms = document.querySelectorAll('.js-viewMore');
  if(!viewMoreElms.length) return;

  viewMoreElms.forEach(elm => {
    const btnElm = elm.querySelector('.js-viewMoreBtn');
    const contentElm = elm.querySelector('.js-viewMoreContent');

    btnElm.addEventListener('click', () => {
      const contentHeight = contentElm.scrollHeight;
      gsap.to(contentElm, { height: contentHeight, duration: 0.4, ease: 'power1.inOut' });
      contentElm.classList.add('is-active');
      btnElm.classList.add('is-hidden');
    });
  });
}

export {
  init
}